<template lang="pug">
  ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
    v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
      v-container(fluid)
        v-row
          v-col(cols="12" sm="6")
            BaseTextField(rules="required" v-model="form.name", :label="translations.label.name")
          v-col(cols="12" sm="6")
            ValidationProvider(rules="required" v-slot="{ errors }")
              v-select(:items="operatorsListAll" v-model="form.operator")
                template(v-slot:label)
                  v-icon.pr-1(color="red accent-2" size="12") mdi-asterisk
                  | {{ translations.label.operator }}
              span.red--text.text--accent-2(v-if="errors.length > 0")
                v-icon(color="red accent-2") mdi-alert
                |  {{ errors[0] }}
          v-col(cols="12")
            BaseChipSelectField(rules="required", :items="providersList" v-model="form.providers", :label="translations.label.providers")
        v-row
          v-col(cols="12")
            v-expansion-panels(accordion)
              v-expansion-panel(v-for="(item,ind) in form.banner", :key="ind")
                v-expansion-panel-header
                  .d-flex.justify-space-between
                    p.subtitle-1.mb-0 {{ translations.label.banner.bannersTitle }} {{ ind + 1 }}
                    v-btn.ml-4(v-if="ind != 0" icon @click="removeBanner(ind)")
                      v-icon(size="24" color="red lighten-1") mdi-close-circle
                v-expansion-panel-content
                  v-divider
                  LobbyBanner(:translations="translations" :banner="item" @input="(banner)=>{updateBanner(ind, banner)}", :clearForm="clearForm")
          v-col.text-center(cols="12")
            v-btn(@click="addBanner()")
              v-icon.mr-3(size="24" color="green lighten-1") mdi-plus-circle
              span {{ translations.button.addBanner }}
        v-row
          v-col(cols="12")
            v-expansion-panels(accordion)
              v-expansion-panel(v-for="(item,ind) in form.categories", :key="ind")
                v-expansion-panel-header
                  .d-flex.justify-space-between
                    p.subtitle-1.mb-0
                      v-icon(color="red accent-2" size="18") mdi-asterisk
                      |  
                      | {{ translations.label.category }}: {{ categoryName(item) }}
                    v-btn.ml-4(v-if="ind != 0" icon @click="removeCategory(ind)")
                      v-icon(size="24" color="red lighten-1") mdi-close-circle
                v-expansion-panel-content
                  v-divider
                  LobbyCategory(:gamesListAll="gamesListAll"
                    :translations="translations"
                    :clearForm="clearForm"
                    @input="(category)=>{updateCategory(ind, category)}"
                    @addedItem="addedItem"
                    @deleteItem="deleteItem")
          v-col.text-center(cols="12")
            v-btn(@click="addCategory()")
              v-icon.mr-3(size="24" color="green lighten-1") mdi-plus-circle
              span {{ translations.button.addCategory }}
        v-row(v-if="Object.keys(form.gamesResumed).length")
          v-col(cols="12")
            table.lobby-game-table
              tr
                th {{ translations.label.games }}
                th {{ translations.label.gamesimg }}
                th {{ translations.label.extra.isNew }}
                th {{ translations.label.extra.hot }}
                th {{ translations.label.extra.featured }}
              LobbyGameRow(v-for="(game) in form.gamesResumed", :key="game.value" :game="game", :translations="translations" @input="inputGame")
        v-row
          v-col.pa-2.pa-md-6(cols="12")
            v-btn.float-right.big(:disabled="invalid || !fillFirstCategory"
              color="primary"
              type="submit"
              :loading="loadingCreate") {{ translations.button.create }}
              
</template>

<script>

  import LobbyBanner from "../components/LobbyBanner";
  import LobbyCategory from "../components/LobbyCategory";
  import LobbyGameRow from "../components/LobbyGameRow";

  export default {
    name: "LobbyCreate",
    components: {
      LobbyCategory,
      LobbyBanner,
      LobbyGameRow
    },
    props:{
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      providersList:{
        type: Array,
        default: function(){
          return []
        }
      },
      operatorsListAll: {
        type: Array,
        default: function(){
          return []
        }
      },
    },
    data:() => ({
      test: null,
      form:{
        name: '',
        operator: null,
        providers: null,
        banner: [{
          title: '',
          description: '',
          imageDesktop: '',
          imageMobile: '',
          url: '',
        }],
        categories: [{
          names: [],
          icon: '',
          img: '',
          games: []
        }],
        gamesResumed: {},
      },
    }),
    computed: {
      fillFirstCategory() {
        return Object.values(this.form.categories[0]).join('').length > 0;
      },
      loadingCreate() {
        return this.$store.state.statusCode.createLobbies.loading;
      },
      stateCreate() {
        return this.$store.state.statusCode.createLobbies.state;
      },
      gamesListAll() {
        return this.$store.state.games.map(game => ({
          text: `${game.n} - ${game.p.n} - ${game.l[0]}`,
          value: game._id
        }));
      },
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.clearFields();
          this.$refs.validator.reset();
        }
      },
      stateCreate: function(val){
        if (val == 200){
          this.$emit('successCreate');
        }
      },
    },
    created(){
      this.clearFields();
      this.$store.dispatch('getGames');
    },
    methods:{
      submitDataForm(){
        let banner = this.form.banner
        let categories = this.form.categories
        let games = Object.keys(this.form.gamesResumed).map((key)=>({
          ...this.form.gamesResumed[key]
        }))
        let formSend = {
          data: {
            name: this.form.name,
            operator: this.form.operator,
            providers: this.form.providers.map((provider)=>(provider.value)),
          },
        };
        if (banner.length > 1 || Object.values(banner[0]).join('').length > 0) {
          formSend.data.banner = banner;
        }
        if (categories.length > 1 || this.fillFirstCategory) {
          formSend.data.categories = categories;
        }
        if (games.length) {
          formSend.data.games = games;
        }
        this.$store.dispatch('createLobbies', formSend);
      },
      clearFields(){
        this.form.name = '';
        this.form.operator = null;
        this.form.providers = null;
        this.form.banner = [{
          title: '',
          description: '',
          imageDesktop: '',
          imageMobile: '',
          url: '',
        }];
        this.form.categories = [{
          names: [],
          icon: '',
          img: '',
          games: [],
        }];
        this.form.gamesResumed = {};
      },
      categoryName(item){
        if(item.names.length > 0){
          return item.names[0].text;
        }
        return this.translations.label.new;
      },
      addCategory(){
        this.form.categories.push({
          names: [],
          icon: '',
          img: '',
          games: [],
        })
      },
      removeCategory(ind){
        this.form.categories.splice(ind, 1);
      },
      updateCategory(ind, category){
        this.form.categories[ind].names = category.names;
        this.form.categories[ind].icon = category.icon;
        this.form.categories[ind].img = category.img;
        this.form.categories[ind].games = category.games;
      },
      addedItem(game){
        if(this.form.gamesResumed[game.value] === undefined) {
          this.form.gamesResumed[game.value] = {
            value: game.value,
            text: game.text,
            img: '',
            inCategories: 1,
            extra: {
              isNew: false,
              featured: false,
              hot: false,
            }
          }
        } else {
          this.form.gamesResumed[game.value].inCategories = this.form.gamesResumed[game.value].inCategories + 1
        }
      },
      deleteItem(game){
        if(this.form.gamesResumed[game.value].inCategories === 1) {
          delete this.form.gamesResumed[game.value]
        } else {
          this.form.gamesResumed[game.value].inCategories = this.form.gamesResumed[game.value].inCategories - 1
        }
      },
      inputGame(game){
        this.form.gamesResumed[game.value].img = game.img
        this.form.gamesResumed[game.value].extra.isNew = game.extra.isNew
        this.form.gamesResumed[game.value].extra.featured = game.extra.featured
        this.form.gamesResumed[game.value].extra.hot = game.extra.hot
      },
      addBanner(){
        this.form.banner.push({
          title: '',
          description: '',
          imageDesktop: '',
          imageMobile: '',
          url: '',
        })
      },
      removeBanner(ind){
        this.form.banner.splice(ind, 1);
      },
      updateBanner(ind, banner){
        this.form.banner[ind].title = banner.title;
        this.form.banner[ind].description = banner.description;
        this.form.banner[ind].imageDesktop = banner.imageDesktop;
        this.form.banner[ind].imageMobile = banner.imageMobile;
        this.form.banner[ind].url = banner.url;
      },
    }
  }
</script>

<style lang="sass">
.lobby-game-table
  box-shadow: 0 0 0 1px #999
  width: 100%
</style>